/** @format */

import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./Doctors.css"; // Import the CSS file for styling
import { Helmet } from "react-helmet";

// Doctors Component
const Doctors = () => {
	return (
		<>
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify({
						"@context": "https://schema.org",
						"@type": "Physician",
						name: "Dr. Raja Chaitanya Reddy",
						medicalSpecialty: "Neuro Surgeon",
						address: {
							"@type": "PostalAddress",
							streetAddress:
								"6-2-119/1, Kakaji Colony, Kakaji Nagar Colony, Hanamkonda, Telangana 506001, India",
						},
						affiliation: "Hospital",
						contactPoint: {
							"@type": "ContactPoint",
							telephone: "8686101203",
							contactType: "Appointment",
						},
					})}
				</script>
				<title>Dr. Raja Chaitanya Reddy | Sri Rajarajeshwara Clinics</title>
				<meta
					name="description"
					content="Book your appointment with Dr. Raja Chaitanya Reddy, a top Medical Neuro Surgeon in Hanumakonda, at Sri Rajarajeshwara Clinics. Call @+91 8686101203."
				/>
				<meta
					name="keywords"
					content="doctor, specialist , Neuro Surgeon, Hanumakonda, Sri Rajarajeshwara Clinics, Brain Spine Specialist, Diabetic Neuropathy, 
					Alcoholic Neuropathy, and Neurological Disorders, Treatment for: Paralysis, Fits, Headache, Neck Pain, Back Pain, Tingling Sensation, Cancer-Related Weakness, 
					Nerve Compression, Nerve Weakness, and Hand/Leg Problems"
				/>
			</Helmet>

			<div className="doctors-section" id="doctors">
				<Container>
					<h2 className="section-title text-center mb-5">Our Doctor</h2>
					<Row className="justify-content-center">
						{/* Doctor 1 */}
						<Col md={12} className="doctor-col">
							<Card className="doctor-card">
								<Row className="align-items-center">
									<Col md={6}>
										<Card.Img
											variant="top"
											src="/drraj.jpg"
											alt="Dr. Raj Chaitanya Reddy"
											className="doctor-img"
										/>
									</Col>
									<Col md={6}>
										<Card.Body>
											<Card.Title>Dr. Raja Chaitanya Reddy</Card.Title>
											<Card.Text>
												**Qualifications:** MBBS, MS, MCh (Neurosurgery)
											</Card.Text>
											<Card.Text>
												Dr. Raja Chaitanya Reddy is a renowned neurosurgeon with
												over 7 years of experience in treating complex
												neurological conditions. He specializes in brain and
												spine surgeries, including minimally invasive
												procedures, brain tumor removal, and spine trauma
												management.
											</Card.Text>
											<Card.Text>
												Dr. Raja Chaitanya Reddy performed over 1600+ successful
												neurosurgical procedures.
											</Card.Text>
											<Card.Text>
												Dr. Raja Chaitanya Reddy is committed to providing
												compassionate care, ensuring each patient receives
												personalized treatment designed to improve their quality
												of life. He believes in listening to his patients and
												guiding them through every step of their recovery
												journey.
											</Card.Text>
										</Card.Body>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		</>
	);
};

export default Doctors;
